import { useMemo } from "react";
import { useAppContext } from "../context/AppContext";
import { getLogoSrc } from "../utils/logoUtils";

export const useLogoSrc = (): string => {
  const { currentLanguage, translationData } = useAppContext();

  return useMemo(() => {
    const isLanguageLoaded = Boolean(
      translationData && translationData.language === currentLanguage
    );
    return getLogoSrc(currentLanguage, isLanguageLoaded);
  }, [currentLanguage, translationData]);
};
